import { graphql } from '@/gql';
import type { HomeServiceOrderProviderPaymentInputType } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { HomeServiceOrderProviderPayment } from '@/models/homeService';

// Fragments
import './fragments/homeServiceOrderProviderPaymentFragment';

export const createHomeServiceOrderProviderPayment = async (data: HomeServiceOrderProviderPaymentInputType) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation CreateHomeServiceOrderProviderPayment($data: HomeServiceOrderProviderPaymentInputType!) {
        createHomeServiceOrderProviderPayment(data: $data) {
          ...HomeServiceOrderProviderPaymentFragment
        }
      }
    `),
  });

  return response.data?.createHomeServiceOrderProviderPayment as HomeServiceOrderProviderPayment;
};
